<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" sm="3" md="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <ftp-configuration-form v-model="config" :readonly="!editMode" :mode="mode"></ftp-configuration-form>
      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'create'">
          <b-button v-if="mode === 'create'"
            @click="createConfig" variant="primary">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canEditConfig">
          <b-button
            @click="editModeActivate" variant="primary">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canDeleteConfig">
          <b-button
            @click="deleteConfig" variant="primary">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === true">
          <b-button variant="primary"
            @click="editConfig">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'
import FTPConfigurationForm from "@/pages/routing/FTP/FTPConfigurationForm.vue";


export default {
  name: 'FTPConfigurationDetails',
  components: {
    'back-button': backButton,
    'page-outline': PageOutline,
    'ftp-configuration-form': FTPConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    entitiesType: {
      type: String,
      default: "rvm"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.firstOn().rights.rightIs('FTP_delete', true)
    },
    canEditConfig () {
      return this.$engine.firstOn().rights.rightIs('FTP_modify', true)
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.ftp_details') : this.$t('Webheader.ftp_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      editMode: false,
      returnUrl: '',
      // returnUrl: this.entitiesType === 'rvm' ? '/entitiessettings/rvm/BICRVM': `/entitiessettings/${this.entitiesType}/Corporate`,
      savedConfig: []
    }
  },
  created () {
    this.role = this.$route.query.role
    this.type = this.$route.query.type
    this.returnUrl = `/routing/configlist/${this.role}/${this.type}/${this.entitiesType}`
    this.activateSpinner = true

    if (this.mode === 'details') {
      this.savedConfig = this.$engine.firstOn().routing.config.clickedConfig
      this.fillFields()
      this.$engine.firstOn().routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === '1') {
        let paramsControl = {
          selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: 'SSL',
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          deliveredBy: this.config.certificateConfig.deliveredBy,
          deliveredTo: this.config.certificateConfig.deliveredTo,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.firstOn().security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.firstOn().security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host,
            params.Port = that.config.port,
            params.URI = that.config.uri,
            params.SSLMode = that.config.sslActive,
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            that.$engine.firstOn().routing.config.webService.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: this.returnUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }
        this.$engine.firstOn().routing.config.webService.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdWebService: that.savedConfig.IdWebService
              }
              that.$engine.firstOn().routing.config.webService.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let modeSecurity = this.getmodeSecurity()

      if (this.config.sslActive == '0') {
        let params = {
          Type: 'Config',
          Timeout: this.config.timeout,
          ConnectTimeout: this.config.connectTimeout,
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSL: this.config.sslActive,
          Name: this.config.name,
          IdFTP: this.savedConfig.IdFTP,
          login: this.config.login,
          password: this.config.password,
          SSH: this.config.ssh,
          ModeSecurity: modeSecurity,
          IdVopProvider: this.config.IdVopProvider
        }
        this.$engine.firstOn().routing.config.FTP.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: this.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          this.okMessageBox(this.$t('common.routing.config_edition_error'))
        })
        /*let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn
          //idCertificate: this.savedConfig.idCertificate DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
        }
        this.$engine.firstOn().security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: this.config.privateKeysConfig.name,
            privateKey: this.config.privateKeysConfig.privateKey,
            password: this.config.privateKeysConfig.password,
            passwordVerif: this.config.privateKeysConfig.passwordVerif,
            type: this.config.privateKeysConfig.type
            //idPrivateKey: respPrivateKey.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          }
          this.$engine.firstOn().security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            let params = {
              Host: this.config.host,
              Port: this.config.port,
              URI: this.config.uri,
              SSLMode: this.config.sslActive,
              Name: this.config.name,
              IdWebService: this.savedConfig.IdWebService
            }
            this.$engine.firstOn().routing.config.webService.edit(params)
            .then(resp => {
              that.$f7.modal({
                title: this.$t('common.routing.config_edited'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
            })
          })
        })*/

      } else {
        let params = {
          IdFTP: this.savedConfig.IdFTP,
          Type: "Config",
          Timeout: this.config.timeout,
          ConnectTimeout: this.config.connectTimeout,
          Host: this.config.host,
          SSL: this.config.sslActive,
          Port: this.config.port,
          URI: this.config.uri,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          Keystore: this.config.keystore,
          CA: this.config.ca,
          ModeSecurity: modeSecurity,
          IdVopProvider: this.config.IdVopProvider
        }
        this.$engine.firstOn().routing.config.FTP.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      }
    },
    getmodeSecurity () {
      let modeSecurity = 0
      if (this.config?.controlConfig?.selectedVerif && Array.isArray(this.config.controlConfig.selectedVerif)) {
        if (this.config.controlConfig.selectedVerif.length !== 0){
          let dictionnary = {
            listVerifClientSSL: {
              1: { id: 1, text: this.$i18n.t('common.global.verify_peer'), value: 1 },
              2: { id: 2, text: this.$i18n.t('common.global.ctrl_CRL'), value: 32 },
              3: { id: 3, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 8 },
              4: { id: 4, text: this.$i18n.t('common.global.ctrl_key_size'), value: 16 },
              5: { id: 5, text: this.$i18n.t('common.global.ctrl_expiration'), value: 1024 },
              6: { id: 6, text: this.$i18n.t('common.global.ctrl_CN'), value: 2048 }
            },
            listVerifServerSSL: {
              7: { id: 7, text: this.$i18n.t('common.global.ctrl_CA'), value: 2 },
              8: { id: 8, text: this.$i18n.t('common.global.ctrl_CRL'), value: 256 },
              9: { id: 9, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 64 },
              10: { id: 10, text: this.$i18n.t('common.global.ctrl_key_size'), value: 128 },
              11: { id: 11, text: this.$i18n.t('common.global.ctrl_expiration'), value: 512 },
              12: { id: 12, text: this.$i18n.t('common.global.ctrl_CN'), value: 4096 }
            }
          }


          this.config.controlConfig.selectedVerif.forEach(element => {
            if (element > 6) {
              modeSecurity += dictionnary.listVerifServerSSL[element].value
            } else {
              modeSecurity += dictionnary.listVerifClientSSL[element].value
            }
          })
        }
      }

      return modeSecurity
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.timeout = this.savedConfig.Timeout
      this.config.connectTimeout = this.savedConfig.ConnectTimeout
      this.config.host = this.savedConfig.Host
      this.config.formatName = this.savedConfig.FormatName
      this.config.formatOutName = this.savedConfig.FormatOutName
      this.config.name = this.savedConfig.Name
      this.config.port = this.savedConfig.Port
      this.config.uri = this.savedConfig.Path
      this.config.sslActive = this.savedConfig.SSL
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
      this.config.keystore = this.savedConfig.Keystore
      this.config.ca = this.savedConfig.CA
      this.config.ssh = this.savedConfig.IdSSH
      this.config.controlConfig = this.savedConfig.controlConfig
      this.config.IdVopProvider = this.savedConfig.IdVopProvider
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      // if (this.config.uri === undefined || this.config.uri.length === 0) {
      //   this.okMessageBox(this.$t('common.routing.uri_missing'))
      //   return true
      // }
      if (this.config.sslActive === undefined || this.config.sslActive !== '0' && this.config.sslActive !== '1') {
        this.okMessageBox(this.$t('common.routing.wrong_ssl_active'))
        return true
      }
      if (this.config.sslActive === '1') {
        /*if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
          this.okMessageBox(this.$t('common.global.ctrl_missing'))
          return true
        }
        if (this.config.certificateConfig === undefined) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_desc_missing'))
          return true
        }
        if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.certif_type_missing'))
          return true
        }
        if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
        if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_cn_missing'))
          return true
        }
        if (this.config.privateKeysConfig === undefined) {
          this.okMessageBox(this.$t('common.securityffff'))
          return true
        }
        if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
          return true
        }
        if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
          return true
        }
        if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
          return true
        }
        if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }*/
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: this.returnUrl})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
